import MyFuneralPolicy from './MyFuneralPolicy'

export default MyFuneralPolicy
